
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectsNewHeadline: {
    id: "ProjectsNew.headline",
    defaultMessage: "Please give your object a name:",
  },
});

export default MESSAGES;